import React from 'react';
import Layout from '../components/Layout/';
import Seo from '../components/Seo/';
import Services from '../components/Services/';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';

const ServicesPage = ({ data }) => (
  <Layout>
    <Seo title="Services" keywords={[`social media automation`, `health coach`, `social engagement`]} />
    <Services packageData={data.allPrismicPackages.edges} />
  </Layout>
);

export const query = graphql`
  {
    allPrismicPackages( filter: { uid: { ne: "do-not-delete-this-20190214"} } ) {
      edges {
        node {
          uid
          data {
            name {
              text
            }
            description {
              text
            }
            price
            full_details {
              html
            }
          }
        }
      }
    }
  }
`;

ServicesPage.propTypes = {
  data: PropTypes.object.isRequired
};

export default ServicesPage;
